module.exports = __webpack_public_path__ + "img/2.622a19f4.jpg";